import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'EmailAPI';

export const emailAPI = {
  getEmails: async (limit = 200, showNotification = false) => {
    try {
      const response = await api.get('/email-webhook/emails', { params: { limit } });
      return handleSuccessResponse(response, MODULE_NAME, 'Получение писем', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении писем', showNotification);
    }
  },
};
